"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoLimitGambleChoiceView = void 0;
const IconToggleButton_1 = require("@nolimitcity/slot-launcher/bin/gui/buttons/IconToggleButton");
const PointerStateColorSet_1 = require("@nolimitcity/slot-launcher/bin/gui/buttons/states/sets/PointerStateColorSet");
const PointerStateIconSet_1 = require("@nolimitcity/slot-launcher/bin/gui/buttons/states/sets/PointerStateIconSet");
const Icon_1 = require("@nolimitcity/slot-launcher/bin/gui/displayobjects/Icon");
const ImgLoader_1 = require("@nolimitcity/slot-launcher/bin/loader/ImgLoader");
const GambleAssetConfig_1 = require("../config/GambleAssetConfig");
const FontStatics_1 = require("@nolimitcity/slot-launcher/bin/loader/font/FontStatics");
const gsap_1 = require("gsap");
const NoLimitGamblePlugin_1 = require("../NoLimitGamblePlugin");
class NoLimitGambleChoiceView extends PIXI.Container {
    /**
     * @constructs
     * @param fiftyFiftyClickCb
     * @param wheelClickCb
     */
    constructor(fiftyFiftyClickCb, wheelClickCb) {
        super();
        this._centerX = 360;
        this._fiftyFiftyClickCallback = fiftyFiftyClickCb;
        this._wheelClickCallback = wheelClickCb;
        this.init();
    }
    /**
     * @description To show the view.
     */
    show() {
        this.visible = true;
        this._fiftyFiftyChoiceButton.enable(true);
        this._wheelChoiceButton.enable(true);
        this._toggleTl.restart();
    }
    /**
     * @description When gamble module is all done.
     */
    allDone() {
        this.hide();
    }
    disableButtons() {
        this._fiftyFiftyChoiceButton.enable(false);
        this._wheelChoiceButton.enable(false);
    }
    /**
     * @description To hide the view.
     */
    hide() {
        this.visible = false;
        this.disableButtons();
        this.killTimeline();
    }
    /**
     * @description To init the view.
     */
    init() {
        this.createTitleItem(GambleAssetConfig_1.GambleAssetConfig.GAMBLE_TEXT, [this._centerX, 140], 1).visible = (NoLimitGamblePlugin_1.NoLimitGamblePlugin.apiPlugIn.translations.language !== "us-sweepstakes"); // #47
        this.createTextItem();
        this.createChoiceItems();
        this.createChoiceItemsToggle();
        this.createTitleItem(GambleAssetConfig_1.GambleAssetConfig.FIFTY_FIFTY_TEXT, [190, 245], 0.76);
        this.createTitleItem(GambleAssetConfig_1.GambleAssetConfig.WHEEL_OF_BONUS_TEXT, [550, 245], 0.7);
        this.visible = false;
    }
    /**
     * @description To create the header text.
     */
    createTextItem() {
        const textStyle = new PIXI.TextStyle({
            fill: "#CACACA",
            fontFamily: "Open Sans",
            fontSize: 20,
            fontStyle: FontStatics_1.FontStyle.NORMAL
        }), yPos = 200, item = new PIXI.Text(NoLimitGamblePlugin_1.NoLimitGamblePlugin.apiPlugIn.translations.translate(NoLimitGambleChoiceView.CHOICE_TEXT), textStyle);
        item.anchor.set(0.5);
        item.position.set(this._centerX, yPos);
        this.addChild(item);
    }
    /**
     * @description To create the choice button items.
     */
    createChoiceItems() {
        const fiftyPosX = 100, wheelPosX = 460, posY = 280, colors = new PointerStateColorSet_1.PointerStateColorSet(0xffffffff), onIconsFiftyFifty = new PointerStateIconSet_1.PointerStateIconSet(new Icon_1.Icon(ImgLoader_1.ImgLoader.getImgTexture(GambleAssetConfig_1.GambleAssetConfig.FIFTY_FIFTY_CHOICE))), onIconsWheel = new PointerStateIconSet_1.PointerStateIconSet(new Icon_1.Icon(ImgLoader_1.ImgLoader.getImgTexture(GambleAssetConfig_1.GambleAssetConfig.WHEEL_CHOICE))), fiftyFiftyBtn = new IconToggleButton_1.IconToggleButton(NoLimitGambleChoiceView.FIFTY_FIFTY_CHOICE_BUTTON, onIconsFiftyFifty, colors), wheelBtn = new IconToggleButton_1.IconToggleButton(NoLimitGambleChoiceView.WHEEL_CHOICE_BUTTON, onIconsWheel, colors);
        fiftyFiftyBtn.addClickCallback(() => this._fiftyFiftyClickCallback());
        fiftyFiftyBtn.toggled = false;
        fiftyFiftyBtn.position.set(fiftyPosX, posY);
        this._fiftyFiftyChoiceButton = fiftyFiftyBtn;
        wheelBtn.addClickCallback(() => this._wheelClickCallback());
        wheelBtn.toggled = false;
        wheelBtn.position.set(wheelPosX, posY);
        this._wheelChoiceButton = wheelBtn;
        this.addChild(fiftyFiftyBtn, wheelBtn);
    }
    /**
     * @description To create the different title text image items.
     */
    createTitleItem(name, pos, scale) {
        let item = new PIXI.Sprite(ImgLoader_1.ImgLoader.getImgTexture(name));
        item.anchor.set(0.5);
        item.scale.set(scale);
        item.position.set(pos[0], pos[1]);
        this.addChild(item);
        return item;
    }
    /**
     * @description To create the blinking toggle timeline for the choice buttons.
     */
    createChoiceItemsToggle() {
        const fiftyToggle = new PIXI.Sprite(ImgLoader_1.ImgLoader.getImgTexture(GambleAssetConfig_1.GambleAssetConfig.FIFTY_FIFTY_CHOICE_TOGGLE)), wheelToggle = new PIXI.Sprite(ImgLoader_1.ImgLoader.getImgTexture(GambleAssetConfig_1.GambleAssetConfig.WHEEL_CHOICE_TOGGLE)), toggleTl = new gsap_1.TimelineLite({
            paused: true,
            onComplete: () => {
                this._toggleTl.restart();
            }
        }), fiftyPosX = 100, wheelPosX = 460, posY = 280, duration = 0.4;
        fiftyToggle.visible = false;
        fiftyToggle.position.set(fiftyPosX, posY);
        wheelToggle.visible = false;
        wheelToggle.position.set(wheelPosX, posY);
        toggleTl.add(() => {
            fiftyToggle.visible = true;
        });
        toggleTl.add(() => {
            fiftyToggle.visible = false;
            wheelToggle.visible = true;
        }, duration);
        toggleTl.add(() => {
            wheelToggle.visible = false;
        }, (2 * duration));
        this._toggleTl = toggleTl;
        this._fiftyToggle = fiftyToggle;
        this._wheelToggle = wheelToggle;
        this.addChild(fiftyToggle, wheelToggle);
    }
    /**
     * @description To kill the toggle timeline.
     */
    killTimeline() {
        this._toggleTl.pause();
        this._toggleTl.kill();
        this._fiftyToggle.visible = false;
        this._wheelToggle.visible = false;
    }
}
exports.NoLimitGambleChoiceView = NoLimitGambleChoiceView;
NoLimitGambleChoiceView.CHOICE_TEXT = "Choose 50/50 or Wheel of Bonus!";
NoLimitGambleChoiceView.FIFTY_FIFTY_CHOICE_BUTTON = "fiftyFiftyChoiceButton";
NoLimitGambleChoiceView.WHEEL_CHOICE_BUTTON = "wheelChoiceButton";
//# sourceMappingURL=NoLimitGambleChoiceView.js.map